export const STATE_CONSTANTS_PROGRAM = {
  MY_WASH: "My Wash",
  MY_DRY: "My Dry",
  MY_IRON: "My Iron",
  MY_SHOE: "My Shoes",
  MY_WATER: "My Water",
  MY_EXTRA: "My Extra",
};

export const STATE_CONSTANTS_ORDER = {
  CURRENT: "CURRENT",
  LOGIN: "LOGIN",
  ORDER: "ORDER",
  SUCCESS: "SUCCESS",
};

export const STATE_CONSTANTS_ADDRESS = {
  EMPTY: "EMPTY",
  SELECT: "SELECT",
  NOT_FOUND: "NOT_FOUND",
  FOUND: "FOUND",
  SEARCH: "SEARCH",
  MY_LOCATION: "MY_LOCATION",
};

export const STATE_CONSTANTS_PROFILE = {
  CURRENT: "CURRENT",
  LOGIN: "LOGIN",
  SELECT_COUNTRY: "SELECT_COUNTRY",
  PROFILE: "PROFILE",
};

export const STATE_CONSTANTS_LOGIN = {
  PHONE_NUMBER: "PHONE_NUMBER",
  COUNTRY_CODE: "COUNTRY_CODE",
  OTP: "OTP",
  COMPLETE_PROFILE: "COMPLETE_PROFILE",
};

export const STATE_CONSTANTS_STATUS = {
  PICK_UP: "PICK_UP",
  AT_THE_STORE: "AT_THE_STORE",
  READY_FOR_RETURN: "READY_FOR_RETURN",
  WASHING: "WASHING",
  RETURNED: "RETURNED",
  CANCELED: "CANCELED",
};
